import { i18n } from '@/local/index';

const { t } = i18n.global;

export const REVIEW_SAMPLE_LIMIT = 10;
export const API_PRICE_DEAL_TYPE = 'DEAL';
export const RECOMMEND_LIST_COLUMNS_NUMBER = 3;
export const API_MAX_ASINS_LENGTH = 20;
export const REMOVE_BACKGROUND_CODE = '_AC_SY400_';
export const SEARCH_RESULT_PARAMS_SORT = 'relevancerank';
export const APP_APLUS_SLOT_NAME = 'aplus-product-description';
export const BRAND_STORE_NAV_SEARCH_OPACITY = 0.5;
//  Use the eighth asin image as the nav image
export const NAV_IMAGE_INDEX = 7;

export const NAV_IMAGE_CLASS_NAME = {
  HORIZONTAL_RECTANGLE: 'brand-store-asin-horizontal-rectangle',
  SQUARE: 'brand-store-asin-square',
  VERTICAL_RECTANGLE: 'brand-store-asin-vertical-rectangle'
};

// Identify product quantity OUT_ OF_ STOCK: Out of stock IN_ STOCK: In stock
export const INVENTORY_STATE = {
  OUT_OF_STOCK: 0,
  IN_STOCK: 1
};

export const STOCK_WARNING_THRESHOLD = {
  low: 0,
  high: 10
};

// Price module displays text judgment for discounts
export const DEAL_MODULE_SHOW = {
  DEAL_OF_THE_DAY: {
    priceShow: t('modules.detailPage.DOTD_DISCOUNTED_PRICE'),
    textShow: t('modules.detailPage.DOTD'),
    configType: 'dotdPrice'
  },
  BEST_DEAL: {
    priceShow: t('modules.detailPage.BEST_DEAL_PRICE'),
    textShow: t('modules.detailPage.BEST_DEAL'),
    configType: 'bestPrice'
  }
};

export const ASIN_TEMPORARILY_OUT_OF_STOCK = {
  LEADTIME: 'LEADTIME',
  AVAILABLE_DATE: 'AVAILABLE_DATE',
  UNKNOWN_AVAILABILITY: 'UNKNOWN_AVAILABILITY'
};

export const DETAIL_PAGE_COUPON_SHOW_STATUS = {
  ACTIVE: 'ACTIVE',
  REDEEMED: 'REDEEMED'
};

export const ELIGIBILITY_TERMS_OPEN_TYPE = {
  SHIPMENT_CONFIG: 'shipmentConfig',
  SHIPPING_FEE: 'shippingFee',
  TAX: 'tax',
  ENDORSEMENT: 'endorsement'
};

export const UNAUTHORIZED_PIPL_IMPORT_BOX_ROW_TYPE = [
  'buyingOptions',
  'shipped',
  'express',
  'estimate'
];

// importBox row type
export const IMPORT_BOX_ROW_TYPE = [
  'buyingOptions',
  'shipped',
  'express',
  'address',
  'estimate'
];

// Configure injection component data key
export const CONFIG_PROVIDES = {
  ASIN_DETAILS: 'asinDetails',
  THUMBNAIL_LIST: 'thumbnailList',
  REVIEW_DATA: 'reviewData',
  APLUSCONTENT_DATA: 'aplusContent',
  IS_IN_STOCK: 'isInStock',
  PROMOTION_INFO: 'promotionInfo',
  BRAND_INFO: 'brandInfo',
  BRAND_PRODUCTS_URL: 'brandProductsUrl',
  PRICE_TYPE: 'priceType',
  IS_SHOW_COUPON_BOX: 'isShowCouponBox',
  ASSCOIATE_TOKEN: 'associateToken',
  DETAIL_PAGE_API_CONFIG: 'detailPageConfig',
  IS_SHOW_SOLD_OUT_POPUP: 'isShowSoldOutPopup'
};

// Specification Open Type
export const PRODUCT_SHEET_OPEN_TYPE = {
  ADD_CART: 'add_cart',
  PAY: 'pay',
  VIEW_OTHERS: 'view_others'
};

export const COUNTDOWN_TIME_DIFFERENCE = 1000;
export const ONE_DAY_TIMESTAMP = 24 * 60 * 60 * 1000;
export const FORMAT_ARR = ['D', 'h', 'm', 's']; // format array
export const DENOMINATOR_ARR = [
  24 * 60 * 60 * 1000,
  60 * 60 * 1000,
  60 * 1000,
  1000
]; // format time array

export const DETAIL_PAGE_SERVICE_ERROR_STATUS = {
  401: t(
    'modules.detailPage.LOGIN_INFORMATION_IS_INCORRECT_PLEASE_LOG_IN_AGAIN'
  ),
  400: t('modules.detailPage.API_ERRPR'),
  500: t('modules.detailPage.API_ERRPR')
};
